'use client';

import { getClientTimeZoneFromBrowser, getClientTimeZoneFromCookie, setClientTimeZoneCookie } from "@lib/timezone/index.client";
import { useEffect } from "react";

export const SetTimeZoneClient = () => {
  const refreshTimeZone = () => {
    const currentTimeZone = getClientTimeZoneFromBrowser();
    const storedTimeZone = getClientTimeZoneFromCookie();

    // If the time zone has changed since the last check, update the cookie
    if (
      !storedTimeZone ||
      storedTimeZone.iana !== currentTimeZone.iana ||
      storedTimeZone.offset !== currentTimeZone.offset
    ) {
      setClientTimeZoneCookie();

      // Re-render the page to ensure the new time zone is used on the server side
      window.location.reload();
    }
  };

  useEffect(() => {
    refreshTimeZone();

    // Update timezone cookie when window gains focus
    window.addEventListener('focus', refreshTimeZone);

    return () => {
      window.removeEventListener('focus', refreshTimeZone);
    };
  }, []);

  return null;
};
